export default "__VITE_ASSET__DGve3IxR__"